import ExplainItem from 'components/ExplainItem/ExplainItem';
import * as React from 'react';
import styled from 'styled-components';
import Section from 'wrappers/Section/Section';

interface IProps {
  items?: Array<{ count: string; text: string }>;
  loading: boolean;
}

const defaultItems = [{}, {}, {}];

const createItem = (loading: boolean) => (
  item: { count: string; text: string },
  key: any
) => <Item loading={loading} {...item} key={key} />;

export const Explain: React.SFC<IProps> = props => {
  return (
    <Section>
      <Container>
        <Content>
          {props.items && !props.loading
            ? props.items.map(createItem(props.loading))
            : defaultItems.map(createItem(props.loading))}
        </Content>
      </Container>
    </Section>
  );
};

const Container = styled.div`
  display: flex;
  justify-content: center;
`;

const Item = styled(ExplainItem)`
  padding: 15px;
`;

const Content = styled.div`
  display: flex;
  justify-content: space-around;
  flex: 1;
  @media (max-width: 900px) {
    flex-direction: column;
  }
`;

export default Explain;



// WEBPACK FOOTER //
// ./src/components/Explain/Explain.tsx